import styles from './styles.module.scss';

type TitleInputProps = {
  /** Bulletin title being edited / displayed */
  title: string;
  /** Function that is called when title has changed */
  setTitle: (newTitle: string) => void;
  /** Show title in readonly mode? */
  readOnly?: boolean;
};

/** Renders the bulletin board title input */
export function TitleInput({
  title,
  setTitle,
  readOnly,
}: TitleInputProps): JSX.Element {
  return (
    <input
      readOnly={readOnly}
      className={styles.titleInput}
      value={title}
      placeholder="Write a Title"
      onChange={(e) => setTitle(e.target.value)}
    />
  );
}
